var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 4.66699C8.75 5.63349 7.96652 6.41699 7 6.41699C6.03347 6.41699 5.25 5.63349 5.25 4.66699C5.25 3.7005 6.03347 2.91699 7 2.91699C7.96652 2.91699 8.75 3.7005 8.75 4.66699Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33203 2.33301C10.2986 2.33301 11.082 3.11651 11.082 4.08301C11.082 4.79648 10.6551 5.41023 10.0427 5.68268",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00002 8.16699H6C4.61929 8.16699 3.5 9.28629 3.5 10.667C3.5 11.2193 3.94771 11.667 4.5 11.667H9.5C10.0523 11.667 10.5 11.2193 10.5 10.667C10.5 9.28629 9.38071 8.16699 8.00002 8.16699Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.332 7.58301C11.7127 7.58301 12.832 8.70231 12.832 10.083C12.832 10.6353 12.3843 11.083 11.832 11.083",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.66797 2.33301C3.70147 2.33301 2.91797 3.11651 2.91797 4.08301C2.91797 4.79648 3.34493 5.41023 3.95728 5.68268",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.16797 11.083C1.61568 11.083 1.16797 10.6353 1.16797 10.083C1.16797 8.70231 2.28726 7.58301 3.66797 7.58301",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.8b4045e909d25085fe277b67de8d3637.svg";
export { ForwardRef as ReactComponent };